import {
    LanguageSelectInfo,
    ProductDTO,
    SubGroupSelectInfo,
    TakeRecord,
    TestTakerSearchReportFilters
} from "./TestTakerSearchTypes"
import ApiService from "../../../../../services/ApiService"
import {AxiosResponse} from "axios"
import {NONE_SELECT} from "../../../../../util/Constants"
import {groupMasterStore} from "../../../../common/group/GroupMasterStore"

export namespace TestTakerSearchApi {


    /** @return a list of test taker instances for use in populating the Test Taker Instance list. */
    export async function findReportTableData2025(filters: TestTakerSearchReportFilters): Promise<TakeRecord[]> {

        const reportData = await ApiService.post(`${ApiService.API_URL}reports/`, {
            groupId: filters.selectedSubGroup,
            productId: filters.productId > 0 ? filters.productId : null,
            contentAreaId: filters.selectedLanguage,
            testCode: filters.testCode,
            loginName: filters.loginName,
            firstName: filters.firstName,
            lastName: filters.lastName,
            startDate: filters.startDate?.valueOf?.(),
            endDate: filters.endDate?.valueOf?.(),
            recentActivity: filters.recentActivity,
            assessmentStart: filters.assessmentStart,
        }).then(r => r.data)

        /** Participation Codes are loaded into a select box, but null is an invalid <option> value. These values must be sanitized. */
        return reportData.map((row: TakeRecord) => ({...row, participationCode: row.participationCode ?? NONE_SELECT}))
    }

    /** Currently only fetches direct children, this may be adjusted if we want to include multiple levels of nested subgroup selects */
    export async function getSubGroups(groupId: number): Promise<SubGroupSelectInfo[]> {
        return ApiService.get(`${ApiService.API_URL}reports/groupId/${groupId}/childGroups`)
            .then((r: AxiosResponse) => r.data)
    }

    /** Fetches data on all languages associated with the current filter group */
    export async function getLanguageOptions(groupId: number): Promise<LanguageSelectInfo[]> {
        return ApiService.get(`${ApiService.API_URL}reports/groupId/${groupId}/languages`)
            .then((r: AxiosResponse) => r.data)
    }

    export async function getProductOptions(groupId: number): Promise<ProductDTO[]> {
        return ApiService.get(`${ApiService.API_URL}reports/groupId/${groupId}/products`).then((r: AxiosResponse) => r.data)
    }

    export async function getSsoRootGroup(): Promise<number> {
        const groupId = await ApiService.get(`${ApiService.API_URL}sso/rootGroup`).then((r: AxiosResponse<number>) => r.data)
        await groupMasterStore.selectGroup(groupId)
        return groupId
    }
}